export class TamanhoUniforme {
    tamanho: any[] = [
        {descricao: 'Extra Pequeno', sigla: 'PP'},
        {descricao: 'Pequeno', sigla: 'P'},
        {descricao: 'Médio', sigla: 'M'},
        {descricao: 'Grande', sigla: 'G'},
        {descricao: 'Extra Grande', sigla: 'GG'}
    ];

    getTamanhoUniforme(sigla: string) {
        const tamanho = this.tamanho.find(d => d.sigla.includes(sigla));
        return tamanho ? tamanho.descricao : null;
    }
}
